import { CompletarVendaGhlTab } from './venda/CompletarVendaGhlTab';

const NovaVenda = ({ currentUser, role }) => (
    <>
        <div className="page-header">
            <div className="page-header-left">
                <div>
                    <div className="page-kicker">Vendas</div>
                    <h1 className="page-title">Nova Venda</h1>
                </div>
            </div>
        </div>

        <div className="page-body">
            <CompletarVendaGhlTab currentUser={currentUser} role={role} />
        </div>
    </>
);

export default NovaVenda;
